import { render } from "./CampaignForm.vue?vue&type=template&id=39fdf0e8&scoped=true"
import script from "./CampaignForm.vue?vue&type=script&lang=js"
export * from "./CampaignForm.vue?vue&type=script&lang=js"

import "./CampaignForm.vue?vue&type=style&index=0&id=39fdf0e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fdf0e8"]])

export default __exports__